"use strict";
import React from "react";
import ReactUtils from "../../react_utils";
import DocumentTitle from "react-document-title";
import { History } from "react-router";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Api from "../../api/api";
const bem = ReactUtils.makeBem("review-groups");
function debtorName(debtorName2) {
  if (debtorName2) {
    return debtorName2;
  } else {
    return "No debtor selected";
  }
}
function invoiceNumber(sourceInvoiceNumber) {
  if (sourceInvoiceNumber) {
    return sourceInvoiceNumber;
  } else {
    return "Not found";
  }
}
function standardGroupDisplay(group) {
  return /* @__PURE__ */ React.createElement("div", { key: group.id }, /* @__PURE__ */ React.createElement("h4", null, `Group ${group.number}`), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Invoice #:"), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, invoiceNumber(group.sourceInvoiceNumber))), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Debtor:"), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, debtorName(group.debtorName))), group.documents.length > 0 ? group.documents.map((document, index) => {
    return /* @__PURE__ */ React.createElement("div", { key: document.id, className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Document ", index + 1, ":"), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, document["data"]["document_type"]));
  }) : /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, "No Documents")), /* @__PURE__ */ React.createElement("hr", null));
}
function unassociatedGroupDisplay(group) {
  const possiblePluralizedDocument = group.documents.length === 1 ? "Document" : "Documents";
  return /* @__PURE__ */ React.createElement("div", { key: "unassociated" }, /* @__PURE__ */ React.createElement("h4", null, `Unassociated`), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: "group-value" }, group.documents.length, " ", possiblePluralizedDocument)), /* @__PURE__ */ React.createElement("hr", null));
}
var ReviewGroups = React.createClass({
  mixins: [History],
  getInitialState: function() {
    return {
      submitting: false
    };
  },
  handleSubmit: function(event) {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ submitting: true });
    Api.DocumentBatches.markInvoicesIndexedAndSendTransmission(
      this.props.documentBatchId
    ).then(() => {
      ToDashboardWithFilters(this.props.location, this.history);
    });
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      DocumentTitle,
      {
        "data-component": "ReviewGroups",
        title: "TriumphPay Audit \u2013 Review Invoices"
      },
      /* @__PURE__ */ React.createElement("div", { className: bem("") }, /* @__PURE__ */ React.createElement("h3", null, "Review"), /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.handleSubmit,
          disabled: this.state.submitting,
          className: "review-groups__submit"
        },
        "Submit"
      ), /* @__PURE__ */ React.createElement("hr", null), this.props.groups.map((group) => {
        if (group.number === "unassociated") {
          return unassociatedGroupDisplay(group);
        } else {
          return standardGroupDisplay(group);
        }
      }))
    );
  }
});
export default ReviewGroups;
